import gql from 'graphql-tag';
import * as Urql from 'urql';

import * as Types from './types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetReeferCountQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Container_Insights_Bookings_Expanded_Bool_Exp>;
}>;

export type GetReeferCountQuery = {
  __typename?: 'query_root';
  container_insights_bookings_expanded_aggregate: {
    __typename?: 'container_insights_bookings_expanded_aggregate';
    aggregate?: {
      __typename?: 'container_insights_bookings_expanded_aggregate_fields';
      count: number;
    } | null;
  };
};

export const GetReeferCountDocument = gql`
  query GetReeferCount($where: container_insights_bookings_expanded_bool_exp) {
    container_insights_bookings_expanded_aggregate(
      distinct_on: reefer_id
      where: $where
    ) {
      aggregate {
        count
      }
    }
  }
`;

export function useGetReeferCountQuery(
  options?: Omit<Urql.UseQueryArgs<GetReeferCountQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetReeferCountQuery, GetReeferCountQueryVariables>({
    query: GetReeferCountDocument,
    ...options,
  });
}
